module.exports = __webpack_public_path__ + "img/android2.95b95575.png";